// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"0baafcbe","453":"e05e6e8e"}[chunkId] + ".chunk.js";
};